import styled from 'styled-components'
import { Button } from 'components/atoms'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${ (props) => (props.isMobile ? '100%' : '390px') };
  width: 100%;
  position: relative;
  top: auto;
  left: auto;
  box-shadow: 1px 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };

  //border: ${ (props) =>
    props.isMobile ? '3px solid red' : '3px solid green' };
  min-height: ${ (props) => (props.isMobile ? '100%' : 'auto') };

  @media print {
    display: none;
  }
`

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: ${ (props) => props.theme.colors.weiss };
  box-shadow: 0 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };
`

export const Body = styled.div`
  display: flex;
  ${ (props) => (props.isMobile ? 'overflow: auto;' : '') }
  height: 100%;
  flex-direction: column;
  padding: 30px 15px 20px;
  background: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  box-shadow: 0 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    padding: 30px 20px 20px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.xl } {
    padding: 30px 30px;
  }
`

export const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

export const FilterButton = styled(Button).attrs(() => ({
  className: 'btn-default',
}))`
  width: 100%;
  height: 48px;
`

export const IPhoneSpacer = styled.div`
  width: 100%;
  height: 100px;
`
